
import {
    Datagrid,
    FieldProps, List, ListProps, NumberField,
    Pagination, ReferenceField, ReferenceManyField, SingleFieldList, TextField,
    useFieldValue
} from "react-admin";

import UserFilter from "./UserFilter";
import { EllipsesTextField, OnlineField, LocationField } from "./UserFields";
import UserListActionButtons from "./UserListActionButtons";
import StatusField from './StatusField'
import IpField from "./IpField";
import { ShowMessagesButton } from "./ShowMessagesButton";
import JsonFormatter from "react-json-formatter";
import { MetadataField } from "./MetadataField";
import { Stack, Typography } from "@mui/material";
import { DateTimeField, ImageFieldExt } from "@/src/components";
import { photoUrl } from "@/src/services";
import { ClientField } from "./ClientField";



const UserPagination = () => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />;

const rowStyle = (record: any) => {
    return {
        textDecoration: record?.deleted && "line-through",
    }
}

const dataGridSx = {
    '& .RaDatagrid-headerCell': {
        padding: "4px 8px 4px 8px",
    },
    '& .RaDatagrid-rowCell': {
        padding: "4px 8px 4px 8px",
    },
    '& .RaDatagrid-checkbox': {
        padding: "4px 8px 4px 8px",
    },

}

export const UserList = (props: ListProps) => {

    return (
        <List {...props}
            perPage={25}
            pagination={<UserPagination />}
            sort={{ field: 'createdAt', order: 'DESC' }}
            filters={<UserFilter />}
            // exporter={false}

        >
            <Datagrid rowClick="edit" rowSx={rowStyle}
                sx={dataGridSx}
                expand={<ExpandDetails />}
                bulkActionButtons={<UserListActionButtons />}
            >
                <TextField source="email" />
                <ReferenceManyField label="Photo" perPage={1}
                    reference="photo" target="user" filter={{ moderation: "accepted" }} sort={{ field: "isMain", order: "DESC" }}>
                    <SingleFieldList linkType={false}>
                        <ImageFieldExt source="id" label="Image" getSrc={(photo) => photo && photoUrl(photo, 'tiny')} />
                    </SingleFieldList>
                </ReferenceManyField >
                <EllipsesTextField source="profile.nickname" label="Nickname" />
                <TextField source="profile.age" label="Age" />
                <MetadataField label="AdSource" />
                <ClientField source="client" label="client" />
                <StatusField label="Status" />
                <NumberField source="wallet.credits" label="Cred" variant="body1" color="error" style={{ fontWeight: "bold" }} />
                <NumberField source="wallet.rewards" label="Rwrd" variant="body1" style={{ color: "green", fontWeight: "bold" }} />
                <NumberField source="stats.subjectCnt" label="Subj" variant="body1" style={{ color: "#ff40e6", fontWeight: "bold" }} />
                <NumberField source="stats.actorCnt" label="Act" variant="body1" style={{ color: "#1cbb21", fontWeight: "bold" }} />

                {/* <MultiSourceField sources={["stats.gotLikes", "stats.liked"]} separator="/"  label="Got / Liked" /> */}
                <ShowMessagesButton label="Messages" />

                <OnlineField source="onlineTime" label="Online (Real)" />
                <OnlineField source="lastSeen" label="Last Seen" />

                <DateTimeField source="createdAt" split />

                <ReferenceField label="City" source="profile.city" reference="city">
                    <TextField source="name" />
                </ReferenceField>
                <LocationField source="location" />
                <IpField source="clientIp" />
                {/* <BooleanField source="fake" /> */}
                {/* <BooleanField source="state.notifications.emailBounce" label="Email Bounce" /> */}
            </Datagrid>
        </List>
    )
};

const ExpandDetails = (props: any) => {
    return (
        <JsonField source="metadata" />
    )
}

const JsonField = (props: FieldProps) => {

    const recordValue = useFieldValue(props)
    if (recordValue) {
        const text = JSON.stringify(recordValue);
        const jsonStyle = {
            propertyStyle: { color: 'red' },
            stringStyle: { color: 'green' },
            numberStyle: { color: 'darkorange' }
        };

        return (
            <Stack>
                <Typography variant="caption" gutterBottom>
                    Metadata
                </Typography>
                <Typography component={"div"}>
                    <JsonFormatter json={text} tabWith={4} jsonStyle={jsonStyle} />
                </Typography>
            </Stack>)
    } else {
        return null
    };


}



